// extracted by mini-css-extract-plugin
export default {"wrapper":"jba","container":"kba","box":"lba","title":"mba","rdwrap":"nba","rditem":"oba","rdimage":"pba","name":"qba","heading":"rba","text":"sba","guarantee":"tba","chatbox":"uba"};
    if(module.hot) {
      // 1714422958263
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  